import { Button, DialogActions, DialogContent, Stack, TextField } from "@mui/material";
import Translate from "../../utils/Translate";
import ButtonWithSpinner from "../ButtonWithSpinner";
import { useState } from "react";
import { useApi } from "../../utils/Api";
import { useSnackbar } from "notistack";

export default function DigitalLicenseToContactDialog({
  courseBookingId,
  digitalLicenseId,
  defaultName,
  defaultEmail,
}) {
  if (!!courseBookingId && !!digitalLicenseId) {
    throw new Error("Use either courseBookingId or digitalLicenseId");
  }

  const [name, setName] = useState(defaultName ?? "");
  const [email, setEmail] = useState(defaultEmail ?? "");
  const api = useApi();

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  async function sendEmail() {
    const dto = {
      courseBookingId,
      digitalLicenseId,
      contactName: name,
      contactEmail: email,
    };
    const response = await api.fetch(
      `${import.meta.env.VITE_MAIN_URL}digital/licenses/publish-groups/email`,
      dto,
      "POST",
    );

    if (response && response.isSuccessful) {
      const successMessage = enqueueSnackbar(Translate.get("EmailSent"), {
        variant: "success",
        autoHideDuration: 6000,
        onClick: () => closeSnackbar(successMessage),
      });
      window.history.back();
    }
  }

  return (
    <>
      <DialogContent>
        <Stack direction="column" spacing={2} marginTop={2} minWidth="300px">
          <TextField
            fullWidth
            value={name ?? ""}
            onChange={(event) => setName(event.target.value)}
            label={Translate.get("Name")}
          />
          <TextField
            fullWidth
            value={email ?? ""}
            onChange={(event) => setEmail(event.target.value)}
            label={Translate.get("Email")}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => window.history.back()}>{Translate.get("Cancel")}</Button>
        <ButtonWithSpinner variant="contained" disabled={!name || !email} onClick={sendEmail}>
          {Translate.get("Send")}
        </ButtonWithSpinner>
      </DialogActions>
    </>
  );
}
